// extracted by mini-css-extract-plugin
module.exports = {"module":"app_module__dHsn_"};